import Api from './api';

export default {
  getNotifications: (limit = 5) => Api.get(`notifications?limit=${limit}`),
  getAllNotifications: (available = 0) => Api.get(`notifications/all?available=${available}`),
  seeNotifications: (ids) => Api.post('notifications', { ids }),
};
